import { registerHotKey } from 'next/javascripts/modules/hotkeys/api'

$ ->
  registerHotKey('/', gotoSearch)
  registerHotKey('shift + g', scrollToEnd)
  registerHotKey('g', scrollToTop)
  registerHotKey('a', scrollToComment)
  registerHotKey('r', scrollToComment)
  registerHotKey('esc', endForm)

gotoSearch = (e) ->
  $target = $(e.target)
  return if $target.is '[contenteditable], input, textarea'

  e.preventDefault()
  $('#txt-search').focus()

scrollToEnd = (e) ->
  $target = $(e.target)
  return if $target.is '[contenteditable], input, textarea'

  pageId = tower.stack.currentPage?.el.children().first().attr('id')
  if /^page-repository$/.test(pageId)
    simple.scrollTo
      container: document.querySelector('.repository-main'),
      offset: document.querySelector('.repository-main').scrollHeight,
      animation: false
    return

  if ($todoPage = $('tr-todo-page')).length > 0 && pageId != 'page-todo'
    simple.scrollTo
      container: $todoPage.parent(),
      offset: $todoPage.parent().get(0).scrollHeight,
      animation: false
    return

  simple.scrollTo
    offset: document.body.scrollHeight,
    animation: false

scrollToComment = (e) ->
  $target = $(e.target)
  return if $target.is '[contenteditable], input, textarea'

  pageId = tower.stack.currentPage?.el.children().first().attr('id')
  return unless /^page-message|page-doc|page-file|page-todo|page-calendar-event|reports-answers-show|page-repository$/.test(pageId)

  e.preventDefault()
  $commentForm = $('tr-comment-form.comment-new-form')
  return unless $commentForm.length > 0
  $editor = $('.fake-textarea:visible')

  if $editor.length
    $editor.trigger 'click'
  else
    editor = $commentForm.find('.tr-editor').get(0)
    editor.focus() if editor

  simple.scrollTo
    target: $commentForm,
    animation: false

endForm = (e) ->
  $target = $(e.target)
  return if $target.is '[contenteditable]'
  return unless $target.is 'textarea, input'

  e.preventDefault()
  $targetForm = $target.closest('form')
  $targetForm.find('.btn-x').trigger('click')

gWasPressed = false

scrollToTop = (e) ->
  $target = $(e.target)
  return if $target.is '[contenteditable], input, textarea'

  e.preventDefault()

  pageId = tower.stack.currentPage?.el.children().first().attr('id')

  if gWasPressed
    if /^page-repository$/.test(pageId)
      simple.scrollTo
        container: document.querySelector('.repository-main'),
        offset: 0,
        animation: false
    else if pageId != 'page-todo' && ($todoPage = $('tr-todo-page')).length > 0
      simple.scrollTo
        container: $todoPage.parent(),
        offset: 0,
        animation: false
    else
      simple.scrollTo { offset: 0, animation: false }

  gWasPressed = true
  setTimeout ->
    gWasPressed = false
  , 800
